import { gql } from '@apollo/client';
import { FileType } from '@jbc-year-end-adj/2024/types';
import { ImageUploadSettings } from '@jbc-year-end-adj/2024/types';

export type QueryResult = {
  request: {
    id: string;
    profile: Profile;
  };
  clientSetting: ClientSetting;
};

type Profile = {
  id: string;
  handicapClassification: Handicap;
};

export type HandicapClassification = 'none' | 'normal' | 'special';

export type Handicap = {
  id: string;
  classification: HandicapClassification;
  detail?: string;
  image?: FileType;
};

type ClientSetting = {
  id: string;
  requestImageUploadSettings: {
    handicap: ImageUploadSettings;
  };
};

export const HANDICAP_FRAGMENT = gql`
  fragment Handicap on Profile {
    id
    handicapClassification {
      id
      classification
      detail
      image {
        url
        filename
      }
    }
  }
`;

export const FETCH_WORKING_STUDENT = gql`
  query handicap {
    request {
      id
      profile {
        ...Handicap
      }
    }
    clientSetting {
      id
      requestImageUploadSettings {
        handicap
      }
    }
  }
  ${HANDICAP_FRAGMENT}
`;
